export const baseURL = 'https://api.openweathermap.org/data/2.5';
export const API_KEY = '3dad7d48f5961c441a3e57ae74e8ca1b';